export const SKILL_CATEGORIES = [
  "negocios",
  "produtividade",
  "produto",
  "newortho-dev",
  "dev-frontend",
  "platforms",
  "ai-llm",
  "design",
  "content",
  "projects",
  "data-office",
  "testing",
  "specialized",
  "other",
] as const;

export type SkillCategory = (typeof SKILL_CATEGORIES)[number];

export const ROUTES = {
  home: "/",
  login: "/login",
  dashboard: "/dashboard",
  explorer: "/explorer",
  analytics: "/analytics",
  chat: "/chat",
} as const;

export const PAGINATION = {
  EXPLORER_GRID: 12,
  SKILLS_LIST: 24,
  CHAT_HISTORY: 50,
  CONVERSATIONS: 50,
} as const;

export const APP_VERSION = __APP_VERSION__;
